// extracted by mini-css-extract-plugin
module.exports = {"personalizedSetting":"style_personalizedSetting__V_RwL","title":"style_title__i0s5_"};